module.exports = __webpack_public_path__ + "static/media/logo.23bb66b6.png";